document.addEventListener('DOMContentLoaded', () => {
  // define elements
  const canvasses = Array.from(document.querySelectorAll('.picture'));

  // define flags
  const canvasCount = canvasses.length;
  let count = canvasCount;
  const artistCount = window.artists.length;
  const interval = 6000;

  // init fn
  const init = () => {
    setupPictures();
  };

  // swap
  const swapPictures = () => {
    // get currently visible image
    const currentCanvas = canvasses[count % canvasCount];
    const currentImg = currentCanvas.querySelector('img');

    // append a new image
    const newImg = document.createElement('img');
    newImg.setAttribute('src', currentImg.src.replace(/\/[A-z_]+\.jpg/, `/${window.artists[count % artistCount]}.jpg`));
    currentCanvas.appendChild(newImg);

    // fade out first image and remove
    currentImg.classList.add('fadeOut');
    const _st = setTimeout(() => {
      currentImg.remove();
      clearTimeout(_st);
    }, 1000);

    // increment count
    count = count + 1;
  };

  // setup
  const setupPictures = () => {
    window.setInterval(swapPictures, interval);
  };

  // init
  init();
});
